/* eslint-disable react/react-in-jsx-scope */
import { Button } from "@/components/ui/button";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { hslaToHsva, type HslColor } from "@uiw/react-color";
import Chrome from "@uiw/react-color-chrome";
import { GithubPlacement } from "@uiw/react-color-github";
import { useState } from "react";
import { useTranslation } from "react-i18next";
export const ColorCustomPicker = ({
  color,
  onColorChange,
}: {
  color: HslColor;
  onColorChange: (newColor: string) => void;
}) => {
  const { t } = useTranslation("dashboard", {
    keyPrefix: "evolmap",
  });

  const defaulthsva = hslaToHsva({
    ...color,
    a: 1,
  });
  const [hsva, setHsva] = useState(defaulthsva);
  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button variant={"ghost"}>{t("Personnaliser la couleur")}</Button>
      </PopoverTrigger>
      <PopoverContent className="isolate z-[999999]">
        <Chrome
          color={hsva}
          style={{ float: "left" }}
          placement={GithubPlacement.Right}
          onChange={(color) => {
            setHsva(color.hsva);
            onColorChange(
              `${color.hsla.h}, ${color.hsla.s}%, ${color.hsla.l}%`
            );
          }}
        />
      </PopoverContent>
    </Popover>
  );
};
